/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-mate.chat-error-banner.description': 'チャット履歴は最大 30 日間保存されます。',
  'ai-mate.chat-error-banner.title': '新規チャットを開始',
  'ai-mate.chat-error.description': '<btn>チャットの再読み込み</btn>をお試しください。',
  'ai-mate.chat-error.rate-limited-description':
    'リクエスト数の上限に達しました。しばらくしてからもう一度お試しください。',
  'ai-mate.chat-error.rate-limited-title': 'リクエストが多すぎます',
  'ai-mate.chat-error.rovo-inactive-description':
    'サイトで Rovo が有効になっていないようです。<link>Rovo のセットアップについてご確認ください。</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo は非アクティブです',
  'ai-mate.chat-error.title': '原因不明のエラーが発生しました',
  'conversation-assistant-button.label': 'チャット',
  'conversation-assistant-button.rovo-chat-label': 'Rovo チャット',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'これについて AI に質問',
  'highlight-actions.rovo-chat-explain-option.text': '説明',
  'highlight-actions.rovo-chat-explain-prompt': '次を説明: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'チャットの推奨事項',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'チャットを開く',
  'highlight-actions.rovo-chat-summarize-option.text': '要約',
  'highlight-actions.rovo-chat-summarize-prompt': '次を要約: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'チャット',
  'horizontal-scroll-container.scroll-left': '左にスクロール',
  'horizontal-scroll-container.scroll-right': '右にスクロール',
};
